export default __webpack_public_path__ + "static/media/organizationhighlights.8b6bbadd.svg";